module.exports = __webpack_public_path__ + "static/media/Linkedin.ebfd7553.svg";